<div class="pnl-collaborators" [class.open]="open">
  <header>
      <a [routerLink]="['/app/configuracao']" class="back">Configurações</a>
      <h1>Colaboradores</h1>
      <a (click)="newCollaborator()" class="add">Cadastrar</a>
  </header>

  <section>
    <div class="pnl-collaborators-lst">
      <div *ngFor="let c of collaborators; let i=index" (click)="openDetail(c, i)" [class.active]="i==openid && c.idoperador == collaborator.idoperador">
        <div>
          <span>{{c.nome}} {{c.sobrenome}}</span>
        </div>
        <div>
          <span>{{c.usuario}}</span>
        </div>
        <div>
          <span>{{c.sc_tipo=='A'?'Administrador':'Operador'}}</span>
          <small *ngIf="c.sc_tipo=='O' && c.sc_pedido_empacotador=='S'">Separador</small>
          <small *ngIf="c.sc_tipo=='O' && c.sc_pedido_entregador=='S'">Entregador</small>
        </div>
        <div>
          <span class="tag" [class.ativo]="c.status == 'A'" [class.inativo]="c.status == 'I'">{{c.status=='A'?'Ativo':'Inativo'}}</span>
        </div>
      </div>
    </div>
  </section>

  <aside id="detailCollaborators" class="detail">
    <form [formGroup]="collaboratorsFrm" (ngSubmit)="onSubmit()" novalidate>
      <header *ngIf="!isDeleteCollaborators" [class.dnone]="changeDetail">
        <div class="action-status">
          <div class="ipt-switch">
              <input id="ckStatus" type="checkbox" (change)="updateStatus()" formControlName="status" name="status">
              <label for="ckStatus"></label>
          </div>
          <span>Colaborador {{status.value?'ativo':'inativo'}}</span>
        </div>

        <a (click)="closeDetail()" class="btn-close"></a>

        <div class="btn-option dnone" (click)="toggleOptions()" (mouseout)="hideOptions()" [class.open]="optionOpen">
          <i></i>
          <i></i>
          <i></i>
          <div (mouseover)="clearOptions()" (mouseout)="hideOptions()">
            <a (click)="showDeleteCollaborators()">Excluir colaborador <i class="ic ic-delete"></i></a>
          </div>
        </div>
      </header>

      <header class="actions" [class.dnone]="!changeDetail">
        <strong *ngIf="collaborator.idoperador > 0">Salve as alterações</strong>
        <strong *ngIf="collaborator.idoperador == -1">Salve novo colaborador</strong>
        <button class="btn btn-primary" type="submit">Salvar</button>
        <button (click)="cancelEdit()" class="btn btn-primary-outline" type="button">Cancelar</button>
      </header>

      <section *ngIf="!isDeleteCollaborators" class="detailCollaborators">
        <div class="frm-collaborator dados-gerais">
          <strong>
              Dados gerais
          </strong>
          <div class="frm">
              <div>
                  <label>Nome</label>
                  <input type="text" class="form-control" (keyup)="onChangeDetail()" formControlName="nome" />
              </div>
              <div>
                  <label>Sobrenome</label>
                  <input type="text" class="form-control" (keyup)="onChangeDetail()" formControlName="sobrenome" />
              </div>
          </div>
          <div class="frm">
            <div>
                <label>CPF</label>
                <input type="text" class="form-control" (keyup)="onChangeDetail()" mask="000.000.000-00" formControlName="cpf" />
            </div>
          </div>
        </div>

        <div class="frm-collaborator seguranca">
          <strong>
              Segurança
          </strong>
          <div class="frm">
              <div>
                  <label>Usuário</label>
                  <input type="text" class="form-control" (keyup)="onChangeDetail()" formControlName="usuario" />
              </div>
              <div>
                  <label>Senha</label>
                  <input type="password" class="form-control" (keyup)="onChangeDetail()" formControlName="new_senha" />
              </div>
          </div>
        </div>

        <div class="frm-collaborator nivel_acesso">
          <strong>
              Nível de acesso
          </strong>
          <div class="frm">
            <mat-radio-group formControlName="sc_tipo" (change)="onChangeDetail()">
              <mat-radio-button name="sc_tipo" value="A">Administrador</mat-radio-button>
              <mat-radio-button name="sc_tipo" value="O">Operador</mat-radio-button>
            </mat-radio-group>
          </div>
          <div *ngIf="sc_tipo.value == 'O'" class="frm">
            <mat-checkbox (change)="onChangeDetail()" formControlName="sc_pedido_empacotador">Separador</mat-checkbox>
            <mat-checkbox (change)="onChangeDetail()" formControlName="sc_pedido_entregador">Entregador</mat-checkbox>
          </div>
        </div>
      </section>

      <section *ngIf="isDeleteCollaborators" class="detailCollaboratorsDelete">
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 24 24"><path d="M8.602 3.7c-1.154 1.937-.635 5.227 1.424 9.025.93 1.712.697 3.02.338 3.815-.982 2.178-3.675 2.799-6.525 3.456-1.964.454-1.839.87-1.839 4.004h-1.995l-.005-1.241c0-2.52.199-3.975 3.178-4.663 3.365-.777 6.688-1.473 5.09-4.418-4.733-8.729-1.35-13.678 3.732-13.678 3.321 0 5.97 2.117 5.97 6.167 0 3.555-1.949 6.833-2.383 7.833h-2.115c.392-1.536 2.499-4.366 2.499-7.842 0-5.153-5.867-4.985-7.369-2.458zm15.398 15.8c0 2.485-2.017 4.5-4.5 4.5s-4.5-2.015-4.5-4.5 2.017-4.5 4.5-4.5 4.5 2.015 4.5 4.5zm-2-.5h-5v1h5v-1z"/></svg>
        <h3>Tem certeza que deseja excluir este colaborador?</h3>
      </section>

      <footer *ngIf="isDeleteCollaborators" class="footerCollaboratorsDelete">
        <button type="button" (click)="onDeleteCollaborators()" class="btn btn-danger">Sim! Quero excluir</button>
        <button type="button" (click)="showDeleteCollaborators()" class="btn btn-primary-outline">Cancelar exclusão</button>
      </footer>

      <div *ngIf="showConfirmDelete" class="showConfirmDelete">
          <i class="ic ic-delete-confirm"></i>
          <strong>Excluído com sucesso</strong>
      </div>

      <div class="loading" *ngIf="loadingDetail">
        <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
            <div class="ldio-ns36390yc">
                <div></div>
            </div>
        </div>
      </div>
    </form>
  </aside>

  <div class="loading" *ngIf="loading">
    <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
        <div class="ldio-ns36390yc">
            <div></div>
        </div>
    </div>
  </div>
</div>
